import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Client, ClientField } from '../models';
import { ClientFaq } from '../models/client-faq';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root'
})
export class ClientService {
    latest = new BehaviorSubject<Client | undefined>(undefined);

    constructor(private apiService: ApiService) {}

    load() {
        if (this.latest.getValue() == undefined) this.reload();
    }

    reload() {
        this.getClient(runtimeConfig.clientCode).subscribe((client) => {
            runtimeConfig.clientId = client.clientId;
            this.latest.next(client);
        });
    }

    private getClient(clientCode: string): Observable<Client> {
        return this.apiService.get(`/clients/${clientCode}`);
    }

    getClientFields(applicationPageNumber?: number): Observable<ClientField[]> {
        let params = new HttpParams();
        if (applicationPageNumber)
            params = params.set('applicationPageNumber', applicationPageNumber);
        return this.apiService.get(
            `/clients/${runtimeConfig.clientId}/Fields`,
            params
        );
    }

    getFaqs(): Observable<ClientFaq[]> {
        return this.apiService.get(`/clients/${runtimeConfig.clientId}/faqs`);
    }
}
